<template>
  <div>
    <PageHeader :items="items" />
    <validation-observer ref="simpleRules">
      <div class="card">
        <div class="card-body">
          <div class="row mb-2">
            <div class="col-md-6">
              <validation-provider
                #default="{ errors }"
                name="Invoice Type"
                rules="required"
              >
                <label class="input-label form-label"
                  ><span style="color: red">*</span>&nbsp;{{
                    $t("invoiceType")
                  }}
                </label>
                <multiselect
                  :disabled="true"
                  v-model="form.invoiceType"
                  :key="form.invoiceType"
                  :options="['invoice-correction', 'invoice', 'invoice-storno']"
                  :multiple="false"
                >
                </multiselect>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
            <div class="col-md-6">
              <validation-provider
                #default="{ errors }"
                name="Status"
                rules="required"
              >
                <label class="input-label form-label"
                  ><span style="color: red">*</span>&nbsp;{{ $t("status") }}
                </label>
                <multiselect
                  v-model="form.status"
                  :key="form.status"
                  :options="statusOptions"
                  :multiple="false"
                  :disabled="true"
                >
                </multiselect>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-6">
              <div class="form-group">
                <label class="input-label form-label"
                  ><span style="color: red">*</span>&nbsp;{{ $t("receiver") }}
                </label>
                <validation-provider
                  #default="{ errors }"
                  name="Receiver"
                  rules="required"
                >
                  <MultiSelectInput
                    v-model="form.companyId"
                    :options="customers"
                    label="companyName"
                    trackBy="id"
                    :key="form.companyId"
                    moduleName="customers"
                    :multiple="false"
                    :isDisabled="true"
                    ><template #option="{ props }">
                      <div>
                        <p>
                          {{ props.option.companyNumber }} -
                          {{ props.option.companyName }}
                        </p>
                      </div>
                    </template>
                  </MultiSelectInput>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="input-label form-label"
                  ><span style="color: red">*</span>&nbsp;{{ $t("sender") }}
                </label>
                <validation-provider
                  #default="{ errors }"
                  name="Sender"
                  rules="required"
                >
                  <MultiSelectInput
                    v-model="form.senderId"
                    :options="customers"
                    label="companyName"
                    trackBy="id"
                    :key="form.senderId"
                    moduleName="customers"
                    :multiple="false"
                    :isDisabled="true"
                    ><template #option="{ props }">
                      <div>
                        <p>
                          {{ props.option.companyNumber }} -
                          {{ props.option.companyName }}
                        </p>
                      </div>
                    </template>
                  </MultiSelectInput>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-md-6">
              <validation-provider
                #default="{ errors }"
                name="Start Date"
                rules="required"
              >
                <TextInput
                  v-model="form.startDate"
                  type="date"
                  :disabled="true"
                  :label="$t('startDate')"
                  :tooltipMessage="$t('startDate')"
                  :required="true"
                  :key="form.startDate"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
            <div class="col-md-6">
              <validation-provider
                #default="{ errors }"
                name="End Date"
                rules="required"
              >
                <TextInput
                  v-model="form.endDate"
                  type="date"
                  :disabled="true"
                  :label="$t('endDate')"
                  :tooltipMessage="$t('endDate')"
                  :required="true"
                  :key="form.endDate"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-6">
              <validation-provider
                #default="{ errors }"
                name="Due Date"
                rules="required"
              >
                <TextInput
                  v-model="form.dueDate"
                  type="date"
                  :disabled="true"
                  :label="$t('dueDate')"
                  :tooltipMessage="$t('dueDate')"
                  :required="true"
                  :key="form.dueDate"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
            <div class="col-md-6">
              <TextInput
                v-model="form.invoiceDate"
                type="date"
                :disabled="true"
                :label="$t('invoiceDate')"
                :tooltipMessage="$t('invoiceDate')"
                :key="form.invoiceDate"
              />
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-6">
              <label class="input-label form-label" for="cars">{{
                $t("applyReverseCharge")
              }}</label>

              <input
                id="active"
                :disabled="true"
                class="form-check-input-custom ml-2"
                v-model="form.applyReverseCharge"
                type="checkbox"
              />
            </div>
            <div v-if="referenceInvoiceDetail" class="col-md-6">
              <label class="input-label form-label" for="cars">{{
                $t("referenceInvoice")
              }}</label>

              <p>{{ referenceInvoiceDetail.invoiceNumber }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <TextInput
                v-model="form.externalOrderNumber"
                type="text"
                :disabled="true"
                :label="$t('externalOrderNumber')"
              />
            </div>
            <div class="col-md-6">
              <label class="input-label form-label" for="cars">{{
                $t("customNotesField")
              }}</label>
              <textarea
                :disabled="true"
                class="form-control"
                rows="5"
                v-model="form.customNotesFields"
              />
            </div>
          </div>
        </div>
      </div>
      <CompanyCard :form="form" :user="user" />
      <!-- <div class="row">
        <div class="col-md-5 mt-2">
          <div v-if="form.usedCredits.length > 0" class="card">
            <div class="card-header">
              <h3>{{ $t("creditsInformation") }}</h3>
            </div>
            <div class="card-body">
              <h3 class="mb-1">
                {{ form.caseName }} :
                {{ $formatter(sumCredits, $i18n.locale, "EUR", false, 2, 2) }}
              </h3>
              <div
                v-for="(usedCredit, index) in form.usedCredits"
                :key="index"
                class="ml-1"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <h4>
                    {{ usedCredit.paymentType }} :
                    {{
                      $formatter(
                        usedCredit.totalCost,
                        $i18n.locale,
                        "EUR",
                        false,
                        2,
                        2
                      )
                    }}
                  </h4>
                  <h4>
                    {{ $t("creditsUsed") }} :
                    {{ usedCredit.creditsUsed }}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="card">
        <div class="card-header" aria-label="Products Header">
          <h3 class="card-title">
            {{ $t("products") }}
          </h3>
        </div>
        <div class="table-responsive mt-2">
          <table class="vgt-table striped">
            <thead>
              <tr>
                <!-- <th>{{ $t("pos") }}</th>
                  <th>{{ $t("articleNumber") }}</th> -->
                <th>{{ $t("productName") }}</th>
                <th>{{ $t("caseName") }}</th>
                <th>{{ $t("Quantity") }}</th>
                <!-- <th>{{ $t("tax") }}</th> -->
                <th>{{ $t("credits") }}</th>
                <th>{{ $t("totalCredits") }}</th>
                <th>{{ $t("⌀CreditPrice") }}</th>
                <th>{{ $t("productPrice") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(products, index) in form.products" :key="index">
                <!-- <td>{{ products.pos }}</td>
                  <td>{{ products.articleNumber }}</td> -->
                <td>{{ translatedProductName(products.productName) }}</td>
                <td>{{ form.caseName }}</td>
                <td>{{ products.quantity }}</td>
                <!-- <td>{{ products.tax }}%</td> -->
                <td>
                  {{
                      products.credits
                  }}
                </td>
                <td>
                  {{
                      products.totalCredits
                  }}
                </td>
                <td>
                  {{
                    $formatter(
                      products.creditPrice,
                      $i18n.locale,
                      "EUR",
                      false,
                      2,
                      2
                    )
                  }}
                </td>
                <td>
                  {{
                    $formatter(
                      products.productPrice,
                      $i18n.locale,
                      "EUR",
                      false,
                      2,
                      2
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          v-if="form.products.length > 0"
          class="d-flex align-items-center justify-content-end mt-2"
        >
          <div class="product-total">
            <ul>
              <!-- <li>
                  <h3>{{ $t("netto") }}</h3>
                  <p>
                    {{
                      $formatter(totalNetto, $i18n.locale, "EUR", false, 2, 2)
                    }}
                  </p>
                </li> -->
              <div v-if="!form.applyReverseCharge">
                <li v-for="(tax, index) in calculateTax" :key="index">
                  <h3>Tax {{ tax.percent }}%</h3>
                  <p>
                    {{
                      $formatter(tax.amount, $i18n.locale, "EUR", false, 2, 2)
                    }}
                  </p>
                </li>
              </div>
              <li class="total">
                <h3>{{ $t("total") }}</h3>
                <p>
                  {{
                    $formatter(totalAmount, $i18n.locale, "EUR", false, 2, 2)
                  }}
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-end">
        <b-button
          v-if="form.invoiceType === 'invoice' && form.status !== 'draft'"
          :disabled="isLoading"
          variant="warning"
          @click="cancelInvoice"
          class="d-flex align-items-center gap-1 mr-2"
        >
          <feather-icon icon="PlusIcon" size="12" />
          <span>{{ $t("cancelInvoice") }}</span>
        </b-button>
        <b-button
          :disabled="isLoading"
          variant="success"
          @click="copyInvoice"
          class="d-flex align-items-center gap-1 mr-2"
        >
          <feather-icon icon="PlusIcon" size="12" />
          <span>{{ $t("copyInvoice") }}</span>
        </b-button>
        <b-button
          :disabled="isLoading"
          variant="primary"
          @click="generate('pdf')"
          class="d-flex align-items-center gap-1 mr-2"
        >
          <feather-icon icon="PlusIcon" size="12" />
          <span>{{ $t("generatePdf") }}</span>
        </b-button>
        <b-button
          :disabled="isLoading"
          variant="primary"
          @click="generate('docx')"
          class="d-flex align-items-center gap-1 mr-2"
        >
          <feather-icon icon="PlusIcon" size="12" />
          <span>{{ $t("generateDocx") }}</span>
        </b-button>
        <b-button
          v-if="form.status.includes('warning')"
          :disabled="isLoading"
          variant="primary"
          @click="generate('pdf', true)"
          class="d-flex align-items-center gap-1 mr-2"
        >
          <feather-icon icon="PlusIcon" size="12" />
          <span>{{ $t("generateWarning") }}</span>
        </b-button>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import TextInput from "@/components/TextInput.vue";
import PageHeader from "@/components/PageHeader.vue";
import Multiselect from "vue-multiselect";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import NotificationService from "@/services/notification.service";
import { mapGetters } from "vuex";
import { required, email } from "@validations";
import MultiSelectInput from "@/components/MultiSelectInput.vue";
import CompanyCard from "./components/CompanyCard.vue";
export default {
  components: {
    TextInput,
    PageHeader,
    ValidationProvider,
    ValidationObserver,
    Multiselect,
    MultiSelectInput,
    CompanyCard,
  },
  computed: {
    ...mapGetters("customers", ["customers"]),
    totalNetto() {
      return this.form.products.reduce((sum, product) => {
        return sum + parseFloat(product.productPrice || 0);
      }, 0);
    },
    totalAmount() {
      // Sum all the taxes from calculateTax and add totalNetto
      const totalTaxes = this.calculateTax.reduce((sum, tax) => {
        return sum + parseFloat(tax.amount);
      }, 0);

      return parseFloat(this.totalNetto + totalTaxes).toFixed(2);
    },
    calculateTax() {
      if (this.form.applyReverseCharge) {
        // If reverse charge is applied, all amounts should be zero
        return Object.keys(
          this.form.products.reduce((result, product) => {
            result[product.tax] = 0;
            return result;
          }, {})
        ).map((tax) => ({
          percent: tax,
          amount: "0.00",
        }));
      }

      const groupedProducts = this.form.products.reduce((result, product) => {
        const tax = product.tax;
        if (!result[tax]) {
          result[tax] = [];
        }
        result[tax].push(product);
        return result;
      }, {});

      const result = Object.entries(groupedProducts).map(([tax, products]) => {
        const totalTaxAmount = products.reduce((sum, product) => {
          const nettoTotal = parseFloat(product.productPrice) || 0;
          const taxAmount = (nettoTotal * parseFloat(tax)) / 100;
          return sum + taxAmount;
        }, 0);

        return {
          percent: tax,
          amount: parseFloat(totalTaxAmount).toFixed(2),
        };
      });

      return result;
    },
    items() {
      return [
        {
          text: "Dental Twin",
          to: "/home",
        },
        {
          text: this.$t("invoices"),
          to: "/invoices",
        },
        {
          text: this.$t("show"),
          active: true,
        },
      ];
    },
  },
  data() {
    return {
      statusOptions: [],
      reminderLevels: [],
      invoiceStatus: "",
      form: {
        invoiceType: "",
        companyId: "",
        dueDate: "",
        senderId: "",
        startDate: "",
        endDate: "",
        invoiceDate: "",
        caseName: "",
        externalOrderNumber: "",
        applyReverseCharge: false,
        products: [],

        usedCredits: [],
        status: "",
        invoiceNumber: "",
        customNotesFields: "",
      },
      sumCredits: "",
      referenceInvoiceDetail: "",
      isLoading: false,
      user: {
        first_name: "",
        last_name: "",
      },
      modelData: {},
    };
  },
  async created() {
    await this.$store.dispatch("customers/list");
    this.loadItems();
    let reminders = await this.$store.dispatch("invoiceReminderLevel/list");
    this.reminderLevels = reminders?.data?.data;
    const response = await this.$store.dispatch(
      "invoices/documentAssignmentList"
    );
    this.modelData = response?.data?.data ?? {};
  },
  methods: {
    filterStatusOptions(status) {
      const allOptions = [
        "draft",
        "approved",
        "sent",
        "warning level 1",
        "warning level 2",
        "warning level 3",
        "paid",
      ];

      const statusIndex = allOptions.indexOf(status);

      if (statusIndex !== -1) {
        // Update statusOptions to remove all previous statuses
        this.statusOptions = allOptions.slice(statusIndex);
      } else {
        // If the status is not found, keep all options
        this.statusOptions = allOptions;
      }
    },
    async loadItems() {
      try {
        this.$store.commit("showLoader", true);
        await this.$store
          .dispatch("invoices/show", this.$route.params.id)
          .then((res) => {
            let data = res?.data?.data;
            this.filterStatusOptions(data.status);
            this.invoiceStatus = data.status;
            this.getUser(data.userId);
            this.form.invoiceType = data.invoiceType;
            this.form.customNotesFields = data.customNotesFields;
            this.form.companyId = data.company;
            this.form.senderId = data.sender;
            this.form.dueDate = data.dueDate;
            this.form.startDate = data.startDate;
            this.form.invoiceNumber = data.invoiceNumber;
            this.form.endDate = data.endDate;
            this.form.invoiceDate = data.invoiceDate;
            this.form.status = data.status;
            this.referenceInvoiceDetail = data.referenceInvoiceDetail;
            this.form.externalOrderNumber = data.externalOrderNumber;
            this.form.applyReverseCharge = data.applyReverseCharge;
            this.form.products = data.products;
            this.form.caseName = data.caseName;
            this.form.usedCredits = data.usedCredits ?? [];
            this.sumCredits = data.totalUsedCreditsCost;
          });
      } catch (e) {
        console.error("api error ___", e);
      } finally {
        this.$store.commit("showLoader", false);
      }
    },
    getUser(id) {
      this.$store
        .dispatch("users/show", {
          id: id,
        })
        .then(async (res) => {
          if (res.message_type === "error") {
          } else {
            var response = res?.data;

            this.user.first_name = response.first_name;
            this.user.last_name = response.last_name;
          }
        });
    },
    quantityChanged(event, index) {
      this.form.products[index].nettoTotal =
        event * this.form.products[index].productPrice;
    },
    priceChanged(event, index) {
      this.form.products[index].nettoTotal =
        event * this.form.products[index].quantity;
    },
    async copyInvoice() {
          const totalTaxes = this.calculateTax.reduce((sum, tax) => {
            return sum + parseFloat(tax.amount);
          }, 0);
          this.isLoading = true;
          this.$store.commit("showLoader", true);
          await this.$store
            .dispatch("invoices/create", {
              ...this.form,
              companyId: this.form.companyId?.id ?? "",
              totalAmount: this.totalAmount,
              taxAmount: totalTaxes,
              netto: this.totalNetto,
              status: 'draft'
            })
            .finally(() => {
              this.isLoading = false;
              this.$store.commit("showLoader", false);
              this.$router.push("/invoices");
            });
    },
    async cancelInvoice() {
          const totalTaxes = this.calculateTax.reduce((sum, tax) => {
            return sum + parseFloat(tax.amount);
          }, 0);

          var products = this.form.products.map((product) => {
            return {
              ...product,
              quantity: -1 * parseFloat(product.quantity), // Convert to negative and keep it as string,
              nettoTotal: -1 * parseFloat(product.nettoTotal),
            };
          });
          this.isLoading = true;
          this.$store.commit("showLoader", true);
          if (this.form.status != "paid") {
            await this.$store.dispatch("invoices/updateStatus", {
                id: this.$route.params.id,
                data: {
                    status: 'paid',
                },
            });
          }
          await this.$store
            .dispatch("invoices/create", {
              ...this.form,
              products: products,
              invoiceType: "invoice-storno",
              status: "draft",
              referenceInvoiceId: this.$route.params.id,
              companyId: this.form.companyId?.id ?? "",
              totalAmount: -1 * this.totalAmount,
              taxAmount: -1 * totalTaxes,
              netto: -1 * this.totalNetto,
              customNotesFields:
                "Cancellation invoice to invoice # " + this.form.invoiceNumber,
            })
            .finally(() => {
              this.isLoading = false;
              this.$store.commit("showLoader", false);
              this.$router.push("/invoices");
            });
    },
    async generate(documentType, isWarning = false) {
      let templateId;
      let warningLevel = {};

      if (this.form.status.startsWith("warning level")) {
        const matchedLevel = this.reminderLevels.find(
          (level) => level.levelName === this.form.status
        );
        if (isWarning == true) {
          if (matchedLevel) {
            const { id, ...rest } = matchedLevel; // Destructure to exclude 'id'
            // Copy the matchedLevel object except for the 'id' property
            warningLevel = { ...rest }; // Assign the rest of the properties to warningLevel
          }
        }
        templateId = matchedLevel ? matchedLevel.documentTemplateId : "";
      } else {
        // Handle other cases based on the form status
        switch (this.form.status) {
          case "invoice":
            templateId = this.modelData?.invoiceTemplateId ?? "";
            break;
          case "invoice-correction":
            templateId = this.modelData?.invoiceCorrectionTemplateId ?? "";
            break;
          case "invoice-storno":
            templateId = this.modelData?.invoiceStornoTemplateId ?? "";
            break;
          default:
            templateId = this.modelData?.invoiceTemplateId ?? ""; // Fallback to invoiceTemplateId
        }
      }
      if (templateId != "") {
        // Safeguard to ensure convertDate returns a valid Date object
        const parseDate = (date) => {
          const parsedDate = this.convertDate(date);
          return parsedDate instanceof Date && !isNaN(parsedDate)
            ? parsedDate
            : new Date(date);
        };

        const invoiceDate = this.form?.invoiceDate
          ? parseDate(this.form.invoiceDate)
          : this.formatDateLite(new Date());

        const startDate = this.form?.startDate
          ? parseDate(this.form.startDate)
          : null;

        const endDate = this.form?.endDate
          ? parseDate(this.form.endDate)
          : null;

        const dueDate = this.form?.dueDate
          ? parseDate(this.form.dueDate)
          : null;

        const draftStatusChangeDate = this.form?.invoiceDate
          ? parseDate(this.form.invoiceDate)
          : null;
        const totalTaxes = this.calculateTax.reduce((sum, tax) => {
          return sum + parseFloat(tax.amount);
        }, 0);
        // Create the payload
        const payload = {
          ...this.form,
          invoiceStatus: this.form.status,
          customers: this.form.companyId,
          totalAmount: this.totalAmount,
          totalTaxAmount: totalTaxes,
          totalAmountWithoutTax: this.totalNetto,
          invoiceDate: invoiceDate.toLocaleDateString(),
          startDate: startDate ? startDate.toLocaleDateString() : null,
          endDate: endDate ? endDate.toLocaleDateString() : null,
          dueDate: dueDate ? dueDate.toLocaleDateString() : null,
          draftStatusChangeDate: draftStatusChangeDate
            ? draftStatusChangeDate.toLocaleDateString()
            : "",
          id: templateId,
          output: documentType,
          updatedTime: Date.now(),
          ...warningLevel,
        };

        // Generate the filename
        const filename =
          "invoice-" +
          (this.form.invoiceNumber == null
            ? "draft"
            : this.form.invoiceNumber) +
          `.${documentType}`;

        // Dispatch the action
        this.$store.commit("showLoader", true);
        const response = await this.$store
          .dispatch("documentService/processTemplate", {
            data: payload,
            filename: filename,
            documentType: documentType,
          })
          .finally(() => {
            this.$store.commit("showLoader", false);
          });

        // If response is Blob, convert to Base64
        if (response instanceof Blob) {
          await this.convertBlobToBase64(response);
        }
      } else {
        NotificationService.showError("Please assign document template first");
      }
    },
    convertDate(dateString) {
      // Convert the date string into a Date object
      const date = new Date(dateString);

      // Convert the date to the desired format (Pakistan Standard Time)
      // Forcing timezone shift by setting the time to GMT+0500
      date.setTime(date.getTime() + 5 * 60 * 60 * 1000); // Add 5 hours

      // Return the formatted string
      return date.toString();
    },
    forconvertDate(dateString) {
      // Convert the date string into a Date object
      const date = new Date(dateString);

      // Convert the date to the desired format (Pakistan Standard Time)
      // Forcing timezone shift by setting the time to GMT+0500
      date.setTime(date.getTime() + 5 * 60 * 60 * 1000); // Add 5 hours

      // Return the formatted string
      return date.toString();
    },
    formatDateLite(date, showTime = false) {
      try {
        const m = date.getMonth() + 1;
        const d = date.getDate();
        return `${date.getFullYear()}-${m < 10 ? "0" : ""}${m}-${
          d < 10 ? "0" : ""
        }${d}${showTime ? " " + date.toLocaleTimeString() : ""}`;
      } catch (e) {
        return date;
      }
    },
    convertBlobToBase64(data) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onerror = (err) => {
          reject(err);
        };
        reader.onloadend = () => {
          resolve(reader.result);
        };
      });
    },
  },
};
</script>

<style scoped>
#nprogress {
  position: relative;
  z-index: 9999999;
}

.white-color {
  color: white !important;
}

.vgt-responsive {
  overflow-x: visible !important;
}
</style>
